<template lang="">
  <svg fill="none" viewBox="0 0 36 26">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M34.87 14.37a1.937 1.937 0 000-2.74L24.537 1.297a1.938 1.938 0 00-2.74 2.74l7.026 7.026H2.5a1.938 1.938 0 000 3.874h26.323l-7.026 7.026a1.938 1.938 0 002.74 2.74L34.87 14.37z"
      clip-rule="evenodd"
    />
  </svg>
</template>